export default {
  // template: https://github.com/vuetifyjs/vuetify/issues/4058#issuecomment-450636420
  initializeDraggable() {
    const d = {}
    const selector = '.v-dialog.v-dialog--active'
    const selectorHandle = '.drag-handle'

    const moveInView = function (dialog) {
      if (dialog) {
        dialog.style.left =
          Math.min(
            Math.max(dialog.getBoundingClientRect().left, 0),
            window.innerWidth - dialog.getBoundingClientRect().width
          ) + 'px'
        dialog.style.top =
          Math.min(
            Math.max(dialog.getBoundingClientRect().top, 0),
            window.innerHeight - dialog.getBoundingClientRect().height
          ) + 'px'
      }
    }

    document.addEventListener('mousedown', (e) => {
      const closestDialog = e.target.closest(selector)
      if (
        e.button === 0 &&
        closestDialog != null &&
        e.target.closest(selectorHandle) != null
      ) {
        d.el = closestDialog
        d.mouseStartX = e.clientX
        d.mouseStartY = e.clientY
        d.elStartX = d.el.getBoundingClientRect().left
        d.elStartY = d.el.getBoundingClientRect().top
        d.el.style.position = 'fixed'
        d.el.style.margin = 0
        d.oldTransition = d.el.style.transition
        d.el.style.transition = 'none'
      }
    })

    document.addEventListener('mousemove', (e) => {
      if (d.el) {
        d.el.style.left = d.elStartX + e.clientX - d.mouseStartX + 'px'
        d.el.style.top = d.elStartY + e.clientY - d.mouseStartY + 'px'
      }
    })

    document.addEventListener('mouseup', () => {
      if (d.el) {
        moveInView(d.el)
        d.el.style.transition = d.oldTransition
        d.el = undefined
      }
    })

    window.addEventListener('resize', () => {
      // prevent out of bounds
      const dialog = document.querySelector(selector)
      moveInView(dialog)
    })
  }
}
